export default "__VITE_ASSET__55f2ad23__"